<mat-card style="background-color: #fff; border: 1px solid #c8c8c8; min-height: 400px;">
  <mat-card-content>
    <div class="chart-container" style="position: relative; min-height: 600px">
      <canvas id="{{containerId}}">{{ barChart }}</canvas>
    </div>
  </mat-card-content>
</mat-card>
